import React from "react"
import { TextArea } from "../../common/components/textArea";
import { confirmMessage, messageAlert } from "../../common/components/confirm";
import { AccountData, ScadenzaDto, ScadenzeClient, SendNotificationsRequest } from "../../generated"
import { requiresUser } from "../../login/loginHelpers"
import { GetTable } from "../../common/components/DataTable"
import { EmailEditor } from "../../common/components/emailEditor"
import { cloneDeep, sumBy } from "lodash";
import { links } from "../../routes";
import { RouteComponentProps, useHistory } from "react-router";
import LoginActions from "../../login/LoginActions"
import { CheckBox } from "../../common/components/checkBox2";
import SelectedExpirationsStore from "../SelectedExpirationsStore";
import { FormTextInput } from "../../common/components/textInput";
import { Link } from "react-router-dom";

const Table = GetTable<{ exp: ScadenzaDto, sendEmail: boolean, sendSms: boolean }>();
function calculateSmsCredits(characters: number) {
    if (characters <= 160)
        return 1;
    return Math.ceil(characters / 153);
}

const defaultTexts = {
    smsTemplate: "La manutenzione della Sua caldaia è in scadenza. Chiami il 000-00000000 per pianificare un appuntamento",
    emailTemplate: "La manutenzione della Sua caldaia è in scadenza. Chiami il 000-00000000 per pianificare un appuntamento",
    emailSubject: "Scadenza manutenzione",
};
const useTextData = (): [typeof defaultTexts, (data: typeof defaultTexts) => void, boolean, () => void] => {
    const asString = localStorage.getItem("notificationsTextData");
    const data = (asString ? JSON.parse(asString) : {}) as typeof defaultTexts;
    const [textData, setTextData] = React.useState({
        data: {
            smsTemplate: data.smsTemplate ?? defaultTexts.smsTemplate,
            emailSubject: data.emailSubject ?? defaultTexts.emailSubject,
            emailTemplate: data.emailTemplate ?? defaultTexts.emailTemplate,
        },
        dirty: localStorage.getItem("notificationsTextData") != JSON.stringify(data),
    });

    return [
        textData.data,
        (data: typeof defaultTexts) => setTextData({ data, dirty: localStorage.getItem("notificationsTextData") != JSON.stringify(data) }),
        textData.dirty,
        () => {
            localStorage.setItem("notificationsTextData", JSON.stringify(textData.data));
            setTextData({ data: textData.data, dirty: localStorage.getItem("notificationsTextData") != JSON.stringify(textData.data) });
        }
    ];
}

const Notifications = requiresUser(({ user, scadenze, onSent }: { user: AccountData, scadenze: ScadenzaDto[], onSent: () => void }) => {

    const [texts, setTextData, isDirty, saveTexts] = useTextData();
    const [impiantiData, setImpiantiData] = React.useState(scadenze.map(exp => ({ exp, sendEmail: exp.email != null, sendSms: exp.cell != null })));
    const history = useHistory();
    return <div>
        <Table
            keySelector={exp => exp.exp.idImpianto.toString()}
            data={impiantiData}
        >
            <Table.Column
                header="Cliente"
                template={item => `${item.exp.cognome ?? ""} ${item.exp.nome ?? ""}`}
                orderable={false}
                groupable={false}
            />
            <Table.Column
                header="Email"
                template={item => item.exp.email ?? "Email non presente"}
                orderable={false}
                groupable={false}
            />
            <Table.Column
                header="Cellulare"
                template={item => item.exp.cell ?? "Cellulare non presente"}
                orderable={false}
                groupable={false}
            />
            <Table.Column
                header="Invia Sms"
                headerClassName="text-center"
                className="text-center"
                template={item => item.exp.cell != null && <div>
                    <CheckBox
                        checked={item.sendSms}
                        onChange={checked => {
                            const cloned = cloneDeep(impiantiData);
                            const i = cloned.find(x => x.exp.idImpianto == item.exp.idImpianto)!;
                            i.sendSms = checked;
                            setImpiantiData(cloned);
                        }}
                    />
                </div>
                }
            />
            <Table.Column
                header="Invia Email"
                headerClassName="text-center"
                className="text-center"
                template={item => item.exp.email != null && <div>
                    <CheckBox
                        checked={item.sendEmail}
                        onChange={checked => {
                            const cloned = cloneDeep(impiantiData);
                            const i = cloned.find(x => x.exp.idImpianto == item.exp.idImpianto)!;
                            i.sendEmail = checked;
                            setImpiantiData(cloned);
                        }}
                    />
                </div>
                }
            />
        </Table>
        <div className="row">
            <div className="col-sm-12">
                <div>
                    <strong>Sms residui: </strong>{user.remainingSms} <Link to={links.buySms}>Acquista sms</Link>
                </div>
            </div>
            {
                impiantiData.some(x => x.sendSms) && <div className="col-sm-12 col-lg-6">
                    <h3 style={{ textAlign: "center" }}>
                        <i className="fas fa-sms" /> Testo Sms
                    </h3>
                    <TextArea
                        label="Testo sms"
                        className="w-100"
                        value={texts.smsTemplate}
                        onChange={e => setTextData({ ...texts, smsTemplate: e.target.value })}
                    />
                    <div>Lunghezza messaggio: <strong>{texts.smsTemplate.length}</strong></div>
                    <div>costo: <strong>{calculateSmsCredits(texts.smsTemplate.length)}</strong> sms per messaggio</div>
                </div>
            }
            {
                impiantiData.some(x => x.sendEmail) && <div className="col-sm-12 col-lg-6">
                    <h3 style={{ textAlign: "center" }}><i className="fas fa-at" /> E-mail</h3>
                    <FormTextInput
                        label="Oggetto e-mail"
                        onChange={e => setTextData({ ...texts, emailSubject: e.target.value })}
                        value={texts.emailSubject}
                    />
                    <EmailEditor
                        label="Testo e-mail"
                        onChange={emailTemplate => setTextData({ ...texts, emailTemplate })}
                        initialValue={texts.emailTemplate}
                    />
                </div>
            }
        </div>

        <div className="btn-group">
            <button
                className="btn btn-secondary"
                disabled={!isDirty}
                onClick={saveTexts}
            >
                {isDirty ? <><i className="fas fa-save text-warning" /> Salva testi</> : <><i className="fas fa-check text-success" /> Testi salvati</>}
            </button>
            {
                impiantiData.some(x => ((x.sendEmail && texts.emailSubject && texts.emailTemplate) || (x.sendSms && texts.smsTemplate))) && <button className="btn btn-primary" onClick={async () => {
                    const totalCost = sumBy(impiantiData, exp => exp.sendSms ? calculateSmsCredits(texts.smsTemplate.length) : 0);
                    if (user.remainingSms < totalCost) {
                        await messageAlert(<div>
                            <p>Il tuo credito di <strong>{user.remainingSms}</strong> Sms non è sufficiente.</p>
                            <p><button className="btn btn-link" onClick={() => history.push(links.buySms)}> Acquista almeno {totalCost - user.remainingSms} sms </button> per procedere</p>
                        </div>, "Errore");
                        return;
                    }
                    if (await confirmMessage(<>Stai inviando {impiantiData.filter(c => c.sendSms).length} SMS utilizzando {totalCost} crediti. Vuoi continuare?</>)) {
                        await new ScadenzeClient().inviaNotitiche(new SendNotificationsRequest({
                            smsTemplate: texts.smsTemplate,
                            impiantiSms: impiantiData.filter(x => x.sendSms).map(item => item.exp.idImpianto),
                            emailTemplate: texts.emailTemplate,
                            impiantiEmail: impiantiData.filter(x => x.sendEmail).map(item => item.exp.idImpianto),
                            emailSubject: texts.emailSubject,
                        }));
                        await LoginActions.getAccountInfo();
                        onSent();
                    }
                }
                }>
                    Invia comunicazioni
                </button>
            }
        </div>
    </div >
});

export default ({ history }: RouteComponentProps<{ idImpianti: string }>) => {
    return <div className="card">
        <div className="card-header bg-theme">
            <h3 className="text-white" >Invio messaggi</h3>
        </div>
        <div className="card-body">
            <Notifications
                scadenze={SelectedExpirationsStore.scadenze}
                onSent={() => { history.goBack() }}
            />
        </div>
    </div>
}